<template>
  <v-col cols="12" class="px-md-1">
    <v-expansion-panels v-model="status" flat class="rounded-0">
      <v-expansion-panel class="ev-2 rounded-0">
        <v-expansion-panel-header
          class="py-0 pl-2 pr-4"
          expand-icon="mdi-menu-down"
        >
          <span class="body2-regular">محل {{ place }}</span>
          <v-spacer></v-spacer>
          <div v-if="status != 0" class="my-auto d-flex body2-regular">
            <v-avatar
              size="20"
              class="ml-1 mr-auto logistic-color white--text"
              v-text="data.length"
            ></v-avatar>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="pa-0 force-padding">
          <div v-for="(sender_reciever, i) of data" :key="i">
            <div class="bg-light-blue px-4 py-2 logistic--text body2-regular">
              {{ place + " " + (i + 1) }}
            </div>
            <div class="pt-3 pr-4">
              <div class="mb-3 pb-05 body2-regular">
                <span class="body2-light">نام :</span>
                {{ sender_reciever.name }}
              </div>
              <div class="mb-3 pb-05 body2-regular">
                <span class="body2-light">کد ملی:</span>
                {{ sender_reciever.code }}
              </div>
              <div class="mb-3 pb-05 body2-regular">
                <span class="body2-light">شماره موبایل:</span>
                {{ sender_reciever.phone }}
              </div>
              <div class="mb-3 pb-05 body2-regular">
                <span class="body2-light">تلفن ثابت:</span>
                {{ sender_reciever.land_line }}
              </div>
              <div class="mb-3 pb-05 body2-regular">
                <span class="body2-light">شهر:</span>
                {{ sender_reciever.city }}
                <span class="medium-emp">({{ sender_reciever.ostan }})</span>
              </div>
              <div class="mb-3 pb-05 body2-regular">
                <span class="body2-light">آدرس:</span>
                {{ `${sender_reciever.city} - ${sender_reciever.address}` }}
              </div>

              <div class="mb-2 body2-regular">
                <span class="body2-light">کد پستی:</span>
                {{ sender_reciever.postal_code }}
              </div>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
export default {
  name: "SenderReceiverPanel",
  props: {
    load: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
      validator: function (value) {
        // The value must match one of these strings
        return ["sender", "receiver"].includes(value);
      },
    },
  },
  data() {
    return {
      status: null,
    };
  },
  computed: {
    place() {
      return this.type === "sender" ? "بارگیری" : "تخلیه بار";
    },
    data() {
      let load_sender_reciever = this.load.sendersAndRecievers;
      // this condition will be useless on 1402
      if (!load_sender_reciever.length) {
        return [
          {
            name: this.load[`${this.type}_name`],
            code: this.load[`${this.type}_code`],
            phone: this.load[`${this.type}_phone`],
            land_line: "",
            city:
              this.type == "sender"
                ? this.load.loading_city
                : this.load.destination_city,
            ostan:
              this.type == "sender"
                ? this.load.loading_ostan
                : this.load.destination_ostan,
            address: this.load[`${this.type}_address`],
            postal_code: this.load[`${this.type}_postal_code`],
          },
        ];
      }

      const filterData = [];
      const flag = this.type === "sender" ? true : false;

      load_sender_reciever.map((item, i) => {
        if (item.is_sender === flag) {
          filterData.push(item);
        }
      });

      return filterData;
    },
  },
};
</script>

<style scoped>
.v-expansion-panel-header {
  height: 20px !important;
  max-height: 20px !important;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.center-right {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.bg-light-blue {
  background: rgba(14, 20, 82, 0.04);
}
.pa-0.force-padding >>> .v-expansion-panel-content__wrap {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
</style>
